import { defineComponent as _defineComponent } from 'vue'
import { Heading, ListDisplay } from '@warrenbrasil/nebraska-web';

import { ICategorie } from '@/modules/wealth/services/suggested-portfolio-builder';

interface Props {
  categories: ICategorie[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Products',
  props: {
    categories: null
  },
  setup(__props: any) {



function computedStyle(color: string) {
  return { backgroundColor: color };
}

return { __sfc: true,computedStyle, Heading, ListDisplay }
}

})